import Button from "components/Button";
import DialogComponent from "components/Dialog";

export default class OrthopedicDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
        };
    }

    title = "Ортопедические работы";

    show(hideCb) {
        this.hidCb = hideCb;
        super.show();
    }

    async save(value) {
        this.hide();

        if (this.hidCb?.apply)
            this.hidCb({ ...this.state, value });
    }

    renderButtons() {
        return (
            <div className="buttons flex end gap16">
                <Button
                    label="main.cancel"
                    size="small"
                    type="transparent"
                    onClick={this.hide.bind(this)}
                />
                <div className="flex gap8">
                    <Button
                        label={"Нет"}
                        size="small"
                        onClick={this.save.bind(this, false)}
                    />
                    <Button
                        label={"Да"}
                        size="small"
                        onClick={this.save.bind(this, true)}
                    />
                </div>


            </div>
        );
    }

    renderContent() {
        return (
            <div className="content flex col gap16">
                <div className="text p1">{"Ортопедическая работа в клинике?"}</div>
            </div>
        );
    }
}
